module.exports = __webpack_public_path__ + "media/images/card_logos/amex-logo-8534ca3ae500955b7332b171d6df392c.png";